module.exports = __webpack_public_path__ + "resources/img/img_cloud_architecture_01.bda3013a989eec0db3f7c7b1420ea505.png";